import { render, staticRenderFns } from "./RecoSearchView.vue?vue&type=template&id=ffc3a914&"
import script from "./RecoSearchView.vue?vue&type=script&lang=js&"
export * from "./RecoSearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports